import React from "react";

import { Select } from "ds/Select";
import { SelectProps } from "ds/Select/src/types";

export const Filter = ({ filter }: { filter?: SelectProps<string, { label: string; value: string }> }) =>
  filter ? <Select size="small" placeholder="Filter" {...filter} /> : null;
